function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from "axios";
import moment from 'moment';
export default {
  props: {
    pageId: String,
    limit: Number,
    category: String
  },
  data: function data() {
    return {
      query: "",
      data: [],
      count: 0,
      // url: "https://api.myjson.com/bins/1318u5"
      url: "//".concat(location.host, "/").concat(this.pageId, "/json/archive-list.json")
    };
  },
  mounted: function mounted() {
    this.query = this.setQuery();
    this.loadData();
  },
  methods: {
    setQuery: function setQuery() {
      if (window.location.search === "" || window.location.search === void 0 || window.location.search == null) {
        if (this.category) {
          return {
            category: this.category,
            page: 1
          };
        } else {
          return {
            page: 1
          };
        }
      }

      var variables = window.location.search.split("?")[1].split("&"),
          obj = {};
      variables.forEach(function (v, i) {
        var variable = v.split("=");
        obj[variable[0]] = variable[1];
      });
      return obj;
    },
    setYearData: function setYearData(data) {
      var _this = this;

      if (data === "" || data === void 0 || data == null) return data;
      if (this.query.year === "" || this.query.year === void 0 || this.query.year == null) return data;
      var result = [];
      data.map(function (val, index, array) {
        if (Number(val.fiscalyear) === Number(_this.query.year)) result.push(val);
      });
      return result;
    },
    setMonthData: function setMonthData(data) {
      var _this2 = this;

      if (data === "" || data === void 0 || data == null) return data;
      if (this.query.month === "" || this.query.month === void 0 || this.query.month == null) return data;
      var result = [];
      data.map(function (val, index, array) {
        if (Number(val.month) === Number(_this2.query.month)) result.push(val);
      });
      return result;
    },
    setCategoryData: function setCategoryData(data) {
      var _this3 = this;

      if (data === "" || data === void 0 || data == null) return data;
      if (this.query.category === "" || this.query.category === void 0 || this.query.category == null) return data;
      var result = [];
      var cat = "";
      data.map(function (val, index, array) {
        cat = val;
        val.categories.map(function (val, index, array) {
          if (String(val.basename) === String(_this3.query.category)) result.push(cat);
        });
      });
      return result;
    },
    setOtherParamData: function setOtherParamData(data) {
      if (data === "" || data === void 0 || data == null) return data; // 「トピックスに表示」にチェックをいれていないもの、且つ
      // 対象別が指定されていたら、その条件でも絞り込む（お知らせ）

      var result = [];
      var topics = null;
      var target = null;
      if (this.query.target) target = decodeURI(this.query.target);
      data.map(function (val, index, array) {
        // console.log(Number(val.topics))
        if (Number(val.topics) === 1 && (!target || target === "" || target !== "" && val.target.indexOf(target) !== -1)) result.push(val);
      });
      return result;
    },
    setPublishData: function setPublishData(data) {
      if (data === "" || data === void 0 || data == null) return data; // 公開日が未来の日付である場合は除外（アップ時の衝突防止）
      // 時間もチェックする（入試の予約投稿での事故防止）

      var result = [];
      var now = moment().format('YYYY-MM-DD HH:mm');
      var date;
      data.map(function (val, index, array) {
        date = moment(val.entry_published, 'YYYY-MM-DD HH:mm'); // console.log(moment(date).diff(now, 'minutes'));

        if (moment(date).diff(now, 'minutes') <= 0) result.push(val);
      });
      return result;
    },
    setPageData: function setPageData(data) {
      if (data === "" || data === void 0 || data == null) return data;
      if (this.query.page === "" || this.query.page === void 0 || this.query.page == null || this.query.page > Math.ceil(data.length / this.limit)) this.query.page = 1;
      var page = Number(this.query.page);
      page = page > 0 ? page : 1;
      var min = page === 1 ? page : (page - 1) * this.limit + 1,
          max = min + this.limit - 1;
      var result = [];
      data.map(function (val, index, array) {
        if (index + 1 >= min && index + 1 <= max) {
          var obj = JSON.parse(JSON.stringify(val));
          obj.month = val.entry_date;
          obj.year = val.entry_year;

          if (val.categories.length > 0) {
            obj.categories = val.categories;
          }

          result.push(obj);
        }
      });
      return result;
    },
    loadData: function () {
      var _loadData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios.get(this.url).then(function (res) {
                  var items = _this4.setCategoryData(res.data);

                  items = _this4.setYearData(items); // items = this.setMonthData(items);

                  items = _this4.setOtherParamData(items);
                  items = _this4.setPublishData(items); // setPageData実行前に記事の総数を渡す

                  _this4.$emit("setresults", items.length);

                  items = _this4.setPageData(items);
                  _this4.data = items;
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                // alert("データの取得に失敗しました、リロードしてください。");
                alert(_context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function loadData() {
        return _loadData.apply(this, arguments);
      }

      return loadData;
    }()
  }
};